import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../js/hooks/useAuth';
import LoadingIndicator from '../LoadingIndicator';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadingIndicator />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
} 